<template>
  <div class="w-60 rounded-lg border border-subtle bg-surface-elevation-1 p-2" data-testid="notification-placeholder-card">
    <div class="flex gap-1 mix-blend-multiply">
      <div class="h-3 w-14 rounded-full bg-surface-elevation-2" />
      <div class="h-3 w-8 rounded-full bg-surface-elevation-2" />
    </div>
    <div class="mt-2 flex flex-col gap-1">
      <div class="h-2 w-24 rounded-sm bg-surface-elevation-2" />
      <div class="h-2 w-40 rounded-sm bg-surface-elevation-2" />
      <div class="h-2 w-32 rounded-sm bg-surface-elevation-2" />
    </div>
  </div>
</template>
